/** Lib Imports */
import React from 'react';
import PropTypes from 'prop-types';

/** CSS */
import './Badges.scss';

const Badges = ({ label, type = 'success', showDot = true, className = '' }) => {
    const labelText = label === null || label === undefined ? "" : String(label);

    if (!labelText.trim()) return <span className="no-status">-</span>;

    // Helper to slugify and group statuses
    const getBadgeClass = (typeStr) => {
        const slug = typeStr ? typeStr.toLowerCase().replace(/\s+/g, '-') : 'default';
        if (slug === 'ready-to-schedule' || slug === 'ready-for-next-round') {
            return 'schedule';
        }
        return slug;
    };

    const badgeClass = getBadgeClass(type || labelText);

    return (
        <div className={`status-badge ${badgeClass} ${className}`}>
            {showDot && <span className="dot"></span>}
            {labelText}
        </div>
    );
};

Badges.propTypes = {
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node]),
    type: PropTypes.string,
    showDot: PropTypes.bool,
    className: PropTypes.string,
};

export default Badges;
